import React, { useState } from 'react';
import { sumBy, uniq } from 'lodash';
import { format as formatDate } from 'date-fns';
import { Input } from 'reactstrap';
import numeral from 'numeral';

import firebase from '../firebase';
import { computeTax, computeWithoutTax, } from '../shared/util';
import { conclusiveReferralFee } from '../shared/models/order';
import useDocumentSubscription from './hooks/useDocumentSubscription';
import useTenant from './hooks/useTenant';
import SettingText from './SettingText';

const db = firebase.firestore();

export default function PaymentStatementContent (props) {
  const { agent, rows, productsById, paymentDate, note, } = props;
  const tenant = useTenant();
  const totalAmount = sumBy(rows, 'amount');

  return (
    <div className="payment-statement" style={{ width: 1200, }}>
      <div className="d-flex justify-content-between align-items-center">
        <h3 className="font-weight-bold m-0">
          支払明細書
        </h3>
        <div className="font-weight-bold">支払日: {paymentDate ? formatDate(paymentDate, 'yyyy年MM月末') : formatDate(new Date(), 'yyyy年MM月dd日')}</div>
      </div>
      <div className="mt-5 d-flex justify-content-start">
      </div>
      <div className="mt-4 d-flex justify-content-between">
        <div>
          <h4 className="font-weight-bold m-0">
            {agent.invoiceName ?? agent.name} 御中
          </h4>
          <hr className="my-1" style={{ borderColor: 'black', }}/>
          <div>
            登録番号: {agent.invoiceNumber}
          </div>
        </div>
        <div>
          <SettingText name="poTopRightJa" />
        </div>
      </div>
      <div className="mt-5">
        <table className="table border-2 table-bordered table-sm">
          <thead className="thead-dark text-center">
            <tr>
              <th style={{ width: 200, }}>
                日付
              </th>
              <th style={{ width: 500, }}>
                費目
              </th>
              <th style={{ width: 250, }}>
                金額
              </th>
            </tr>
          </thead>
          <tbody>
            {
              Array(25).fill().map((_, i) => {
                const row = rows[i];
                return (
                  <tr key={i}>
                    <td className="text-center">
                      {row?.date}
                      &nbsp;
                    </td>
                    <td>
                      {row?.description}
                      {row?.orderId && ` (${row.orderId})`}
                    </td>
                    <td className="text-right">
                      {row && <span>&yen;{numeral(row.amount).format('')}</span>}
                    </td>
                  </tr>
                );
              })
            }
            <tr>
              <th colSpan={2} className="text-right">
                合計
              </th>
              <th className="text-right">
                <span>&yen;{numeral(totalAmount).format('')}</span>
              </th>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-4 d-flex justify-content-end">
        <table className="table border-2 table-bordered table-sm" style={{ width: 600, }}>
          <tbody>
            <tr>
              <td style={{ width: 300, }}>
                <div className="d-flex justify-content-between">
                  <div>
                    10%対象(税抜)
                  </div>
                  <div>
                    &yen;{numeral(computeWithoutTax(totalAmount)).format('')}
                  </div>
                </div>
              </td>
              <td style={{ width: 300, }}>
                <div className="d-flex justify-content-between">
                  <div>
                    10%消費税
                  </div>
                  <div>
                    &yen;{numeral(computeTax(totalAmount)).format('')}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td style={{ width: 300, }}>
                <div className="d-flex justify-content-between">
                  <div>
                    8%対象(税抜)
                  </div>
                  <div>
                    &yen;{numeral(0).format('')}
                  </div>
                </div>
              </td>
              <td style={{ width: 300, }}>
                <div className="d-flex justify-content-between">
                  <div>
                    8%消費税
                  </div>
                  <div>
                    &yen;{numeral(0).format('')}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-4">
        <div className="font-weight-bold mb-2">備考</div>
        <div className="border p-2" style={{ minHeight: 100, whiteSpace: 'pre-line' }}>
          {note || ''}
        </div>
      </div>
    </div>
  );
};
